export default __webpack_public_path__ + "images/ac539e31e0b20123bc7bf54b4a53de6e-orlando_mobile.webp";